import intl from "react-intl-universal";
import { Step1Props } from "../types";
import Button from "components/button";

const fullStepKeys = [
  "massTrading",
  "reviewTrading",
  "volumeNegotiation"
];

const Step1: React.FC<Step1Props> = ({ contextModal, content, downloadFile, hiddenButtonExport, startFetching, stopFetching }) => {
  const hasContent = (content: any) => content?.hasFilter;
  const showFullSteps = fullStepKeys.find(elem => elem === contextModal);

  const handleDownloadButtonClick = () => {
    try {
      startFetching();
      downloadFile();
    } catch (e) {
      console.error('Error occurred while downloading the file:', e);
    } finally {
      stopFetching();
    }
  };

  return (
    <>
      {hasContent(content) ? (
        content.component
      ) : (
        <div className="content">
          <span className="title">
            {intl.get(`exportImportModal.${contextModal}.messageStep1-p1`)}
          </span>
          {showFullSteps && (
            <span className="title">
              {intl.get(`exportImportModal.${contextModal}.messageStep1-p2`)}
            </span>
          )}
          {showFullSteps && (
            <span className="title last-title">
              {intl.get(`exportImportModal.${contextModal}.messageStep1-p3`)}
            </span>
          )}
          {!hiddenButtonExport && (
            <div
              className="button-download-content"
              data-testid="button-download-content"
            >
              <Button
                buttonType="secondary"
                className="button-download"
                onClick={handleDownloadButtonClick}
                value={intl.get(`exportImportModal.butttons.download`)}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Step1;
